import CommonDialog from '@/components/common/dialog/CommonDialog.vue'
import { useTemplateRef } from 'vue'

export const useMemberRegistrationSuccessDialog = () => {
  const commonDialog = useTemplateRef<InstanceType<typeof CommonDialog>>('commonDialog')

  const openDialog = async (): Promise<boolean> => {
    if (!commonDialog.value) {
      return false
    }
    return await commonDialog.value
      ?.openDialog()
      .then(() => true)
      .catch(() => false)
  }

  return {
    openDialog
  }
}
